import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "SettingsRowWrapper",
  componentId: "sc-14anmbn-0"
})(["margin-bottom:20px;"]);